<template>
  <div class="col-md-12">
    <Header></Header>
    <div class="header-group">
      <h1>Dans quelle démarche, candidatez-vous à la formation ASV ? </h1>
    </div>
    <div class="col-md-8 type-group" tabindex="0" value="contrat" v-on:click="focus">
      <div class="circle"/>
      <div class="type-content">Contrat d'apprentissage / Contrat de professionnalisation / Contrat Pro A</div>
    </div>

    <div class="col-md-8 type-group" tabindex="0" value="transition" v-on:click="focus">
      <div id="circle" class="circle"/>
      <div class="type-content">Projet de transition professionnelle</div>
    </div>

    <div v-if="type === 'transition'" class="col-md-8 mx-auto no-transition">
      Actuellement, la formation pour devenir ASV avec APFORM est un format uniquement disponible en alternance sur 2 ans (soit 810 heures de formation) via le contrat d’apprentissage ou le contrat de professionnalisation.
    </div>

    <div class="col-md-8 type-group" tabindex="0" value="vae" v-on:click="focus">
      <div id="circle" class="circle"/>
      <div class="type-content">Validation des acquis professionnels (VAE)</div>
    </div>

    <div v-if="type === 'vae'" class="col-md-8 mx-auto no-transition">
      Pour toute demande de VAE , <a href="https://apform.fr/espace-salarie/vae-asv/">cliquez ici</a>.
    </div>

    <div class="login-group">
      <button :disabled='isDisabled' class="btn btn-primary btn-block" v-on:click="register">
        <span>Créer un compte</span>
      </button>

      <div class="login-group-info">Vous avez déjà un compte ?</div>
      <div class="login-group-href">
        <router-link :to="{ name: 'public-login'}">Se connecter</router-link>
      </div>
      <div class="login-group-help">
        <router-link :to="{ name: 'public-help-candidature'}" target="_blank">Aide à la candidature</router-link>
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed, ref} from 'vue'
import {useRouter} from 'vue-router'
import Header from "./Header.vue"
import RouteEnum from "@/router/RouteEnum";

const router = useRouter()
const type = ref(undefined)

const isDisabled = computed(() => {
  return type.value !== 'contrat'
})

const focus = (event) => {
  const actual = document.getElementsByClassName('type-group-selected')[0]
  if (actual !== undefined) {
    actual.classList.remove('type-group-selected')
    actual.classList.add('type-group')
  }

  event.currentTarget.classList.remove('type-group')
  event.currentTarget.classList.add('type-group-selected')
  type.value = event.currentTarget.getAttribute('value')
}

const register = () => {
  localStorage.setItem('typeRegister', type.value)
  router.push({name: RouteEnum.REGISTER_CONDITIONS})
}
</script>
